<template>
  <div class="credit-card-confirm-section">
    <fieldset-confirm-parts
      class="credit-card-confirm-section__number credit-card-confirm-section__input"
      :label="$tc('CreditCardPayment.inputLabel.number')"
      :value="creditCard.number"
    />

    <fieldset-confirm-parts
      class="credit-card-confirm-section__name credit-card-confirm-section__input"
      :label="$tc('CreditCardPayment.inputLabel.name')"
      :value="creditCard.name"
    />

    <fieldset-confirm-parts
      class="credit-card-confirm-section__period credit-card-confirm-section__input"
      :label="$tc('CreditCardPayment.inputLabel.period')"
      :value="creditCard.period"
    />

    <fieldset-confirm-parts
      class="credit-card-confirm-section__cvc credit-card-confirm-section__input"
      :label="$tc('CreditCardPayment.inputLabel.cvc')"
      :value="creditCard.cvc"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api'
import FieldsetConfirmParts from '@/components/common/form/FieldsetConfirmParts.vue'

/**
 * 決済: クレジット入力情報確認セクション
 * Stripe Elementsを使うと入力したクレジットカード情報の取得ができず、確認画面にクレジットカード情報を表示することができなかったため、このコンポーネントは使われていない。
 */
export default defineComponent({
  name: 'CreditCardInputSection',
  components: {
    FieldsetConfirmParts,
  },
  setup() {
    /**
     * クレジットカード情報
     */
    const creditCard = ref({
      number: '1234123412341234',
      name: 'TARO YAMADA',
      period: '1124',
      cvc: '123',
    })
    return {
      creditCard,
    }
  },
})
</script>

<style lang="scss" scoped>
.credit-card-confirm-section {
  padding: 24px 16px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  &__input {
    &:first-child,
    &:not(:first-child) {
      margin-top: 0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>

<style lang="scss">
.credit-card-confirm-section {
  .credit-card-confirm-section__input {
    label {
      color: $gray50;
    }
  }
}
</style>
